import Phaser from 'phaser';

/** A high depth so controls sit above every scene's content (matches audio controls). */
const CONTROL_DEPTH = 1000;

/**
 * Fullscreen toggle button. Uses Phaser's Scale Manager, which requests
 * fullscreen on the game canvas so it fills the whole display. The glyph
 * reflects the current state and stays in sync even when the user leaves
 * fullscreen via Esc or the browser chrome rather than the button.
 */
export function addFullscreenButton(
  scene: Phaser.Scene,
  x: number,
  y: number,
): Phaser.GameObjects.Text {
  const glyph = (): string => (scene.scale.isFullscreen ? '🗗' : '⛶');

  const btn = scene.add
    .text(x, y, glyph(), { fontSize: '22px' })
    .setOrigin(0.5)
    .setDepth(CONTROL_DEPTH)
    .setInteractive({ useHandCursor: true });

  btn.on('pointerup', () => scene.scale.toggleFullscreen());

  // Keep the glyph in sync with the actual state (covers Esc / browser-driven exits).
  const sync = (): void => {
    btn.setText(glyph());
  };
  scene.scale.on(Phaser.Scale.Events.ENTER_FULLSCREEN, sync);
  scene.scale.on(Phaser.Scale.Events.LEAVE_FULLSCREEN, sync);
  scene.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
    scene.scale.off(Phaser.Scale.Events.ENTER_FULLSCREEN, sync);
    scene.scale.off(Phaser.Scale.Events.LEAVE_FULLSCREEN, sync);
  });

  return btn;
}
